import type { z } from 'zod'

import { Normalization } from '~/utils/normalization'

interface CustomizationGroupSelections {
  readonly min_selections?: unknown
  readonly max_selections?: unknown
  readonly selection_type?: string | null | undefined
  readonly options: readonly { readonly is_available?: boolean | null | undefined }[]
}

export const refineCustomizationGroupSelections = (
  value: CustomizationGroupSelections,
  ctx: z.RefinementCtx
): void => {
  const min = Normalization.intValue(value.min_selections, 0) ?? 0
  const max = Normalization.intValue(value.max_selections, 0) ?? 0
  const available = value.options.filter((option) => option.is_available ?? true).length

  if (min > max) {
    ctx.addIssue({
      code: 'custom',
      message: 'The min_selections field must be less than or equal to max_selections',
      path: ['min_selections']
    })
  }
  if (value.selection_type === 'single' && max !== 1) {
    ctx.addIssue({
      code: 'custom',
      message: 'The max_selections must be 1 when selection_type is single',
      path: ['max_selections']
    })
  }
  if (value.selection_type === 'multiple' && max < 2) {
    ctx.addIssue({
      code: 'custom',
      message: 'The max_selections must be at least 2 when selection_type is multiple',
      path: ['max_selections']
    })
  }
  if (available === 0) {
    ctx.addIssue({
      code: 'custom',
      message: 'At least one available option is required',
      path: ['options']
    })
  }
  if (min > available) {
    ctx.addIssue({
      code: 'custom',
      message: 'The min_selections cannot exceed the number of available options',
      path: ['min_selections']
    })
  }
}
